"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _flex = _interopRequireDefault(require("@waglabs/flex"));

var _icon = _interopRequireDefault(require("@waglabs/icon"));

var _link = _interopRequireDefault(require("@waglabs/link"));

var _Container = require("../Container");

var _PersonOutlineIcon = require("./components/PersonOutlineIcon");

var _WalkerIcon = require("./components/WalkerIcon");

var _ListItemIcon = require("./components/ListItemIcon");

var _Navigation = require("./components/Navigation");

var _utils = require("../utils");

var _urls = require("../urls");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var routes = {
  leftRoutes: _utils.helper.attachQueryStringToRoutes([_objectSpread({}, _urls.servicesLinksData, {
    icon: _react["default"].createElement(_ListItemIcon.ListItemIcon, {
      name: "caratDownGreen"
    }),
    iconPosition: _utils.factory.ICON_POSITION.RIGHT,
    screenTypes: [_utils.factory.SCREEN_TYPE.DESKTOP, _utils.factory.SCREEN_TYPE.IPAD]
  }), _objectSpread({}, _urls.wagTagLinksData, {
    key: _urls.wagTagLinksData.url,
    screenTypes: [_utils.factory.SCREEN_TYPE.DESKTOP, _utils.factory.SCREEN_TYPE.IPAD]
  }), _objectSpread({}, _urls.safetyLinksData, {
    icon: _react["default"].createElement(_ListItemIcon.ListItemIcon, {
      name: "caratDownGreen"
    }),
    iconPosition: _utils.factory.ICON_POSITION.RIGHT,
    screenTypes: [_utils.factory.SCREEN_TYPE.DESKTOP]
  }), _objectSpread({}, _urls.helpCenterLinkData, {
    key: _urls.helpCenterLinkData.url,
    screenTypes: [_utils.factory.SCREEN_TYPE.DESKTOP]
  }), _objectSpread({}, _urls.dailyWagLinkData, {
    key: _urls.dailyWagLinkData.url,
    screenTypes: [_utils.factory.SCREEN_TYPE.DESKTOP]
  })]),
  rightRoutes: _utils.helper.attachQueryStringToRoutes([_objectSpread({}, _urls.becomeAWalkerLinkData, {
    key: _urls.becomeAWalkerLinkData.url,
    icon: _react["default"].createElement(_WalkerIcon.WalkerIcon, {
      color: "#01BE8F",
      mr: "8px"
    }),
    iconPosition: _utils.factory.ICON_POSITION.LEFT,
    screenTypes: [_utils.factory.SCREEN_TYPE.DESKTOP],
    navigationItemProps: {
      linkProps: {
        color: 'wagGreen',
        hoverColor: '#00BF8F'
      },
      mr: '20px'
    }
  }), _objectSpread({}, _urls.loginLinkData, {
    key: _urls.loginLinkData.url,
    icon: _react["default"].createElement(_PersonOutlineIcon.PersonOutlineIcon, {
      color: "medGray",
      fontSize: "1rem",
      mr: "8px"
    }),
    iconPosition: _utils.factory.ICON_POSITION.LEFT,
    screenTypes: [_utils.factory.SCREEN_TYPE.DESKTOP, _utils.factory.SCREEN_TYPE.IPAD, _utils.factory.SCREEN_TYPE.MOBILE],
    navigationItemProps: {
      mr: '20px'
    }
  })])
};

var SiteHeader = function SiteHeader(_ref) {
  var onMenuClick = _ref.onMenuClick;
  return _react["default"].createElement(_flex["default"], {
    alignItems: "center",
    bg: "white",
    boxShadow: "0 1px 0 0 #D1D1D1",
    boxSizing: "border-box",
    height: ['50px', '64px', '72px'],
    width: 1
  }, _react["default"].createElement(_Container.Container, null, _react["default"].createElement(_flex["default"], {
    alignItems: "center",
    boxSizing: "border-box",
    height: "100%",
    justifyContent: "space-between",
    py: "8px"
  }, _react["default"].createElement(_flex["default"], {
    alignItems: "center"
  }, _react["default"].createElement(_icon["default"], {
    name: "hamburger",
    mr: "16px",
    width: "24px",
    height: "24px",
    display: ['block', 'block', 'none'],
    onClick: onMenuClick
  }), _react["default"].createElement(_link["default"], {
    href: _urls.homeLinkData.url,
    hover: true
  }, _react["default"].createElement(_icon["default"], {
    name: "wagTextLogo",
    mt: "4px",
    width: ['48px', '60px', '76px'],
    mr: [0, '32px', '40px'],
    hover: true
  })), _react["default"].createElement(_box["default"], {
    display: ['none', 'none', 'block']
  }, _react["default"].createElement(_Navigation.Navigation, {
    data: _utils.helper.filterRoutesByScreenType(_utils.factory.SCREEN_TYPE.DESKTOP)(routes.leftRoutes)
  })), _react["default"].createElement(_box["default"], {
    display: ['none', 'block', 'none']
  }, _react["default"].createElement(_Navigation.Navigation, {
    data: _utils.helper.filterRoutesByScreenType(_utils.factory.SCREEN_TYPE.IPAD)(routes.leftRoutes)
  })), _react["default"].createElement(_box["default"], {
    display: ['block', 'none', 'none']
  }, _react["default"].createElement(_Navigation.Navigation, {
    data: _utils.helper.filterRoutesByScreenType(_utils.factory.SCREEN_TYPE.MOBILE)(routes.leftRoutes)
  }))), _react["default"].createElement(_flex["default"], {
    alignItems: "center"
  }, _react["default"].createElement(_box["default"], {
    display: ['none', 'none', 'block']
  }, _react["default"].createElement(_Navigation.Navigation, {
    data: _utils.helper.filterRoutesByScreenType(_utils.factory.SCREEN_TYPE.DESKTOP)(routes.rightRoutes)
  })), _react["default"].createElement(_box["default"], {
    display: ['none', 'block', 'none']
  }, _react["default"].createElement(_Navigation.Navigation, {
    data: _utils.helper.filterRoutesByScreenType(_utils.factory.SCREEN_TYPE.IPAD)(routes.rightRoutes)
  })), _react["default"].createElement(_box["default"], {
    display: ['block', 'none', 'none']
  }, _react["default"].createElement(_Navigation.Navigation, {
    data: _utils.helper.filterRoutesByScreenType(_utils.factory.SCREEN_TYPE.MOBILE)(routes.rightRoutes)
  })), _react["default"].createElement(_link["default"], {
    bg: "wagGreen",
    borderRadius: "6px",
    border: "1px solid #01BE8F",
    color: "white",
    fontFamily: "body",
    fontSize: ['0.875rem', '1rem'],
    fontWeight: "bold",
    lineHeight: ['18px', '20px'],
    px: "16px",
    py: "4px",
    href: _urls.loginLinkData.url
  }, "Sign up")))));
};

exports.SiteHeader = SiteHeader;